<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">
                <i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <section class="content">
      <b-card-group deck>
        <div class="container-fluid">
          <b-row class="col-lg-12">
            <div class="d-flex justify-content-center w-100 mb-4">
              <b-col class="col-lg-5 mt-4 mx-2">
                <b-card
                  header-tag="header"
                  footer-tag="footer"
                  class="custom-table-card h-100"
                >
                  <template #header>
                    <b>All Tables</b>
                  </template>
                  <b-card-text>
                    <div class="table-list-container">
                      <multiselect
                        v-model="selectedTable"
                        :options="tableOptions"
                        label="label"
                        track-by="value"
                        :multiple="false"
                        :placeholder="'Select Table'"
                        :searchable="true"
                        :internal-search="true"
                        :clear-on-select="false"
                        :show-labels="false"
                        :options-limit="300"
                        :limit="3"
                        :max-height="600"
                        :disabled="!tableOptionsLoaded"
                        :loading="!tableOptionsLoaded"
                      />
                    </div>
                  </b-card-text>
                  <b-button
                    @click="
                      $router.push(
                        '/admin-chat/' +
                          (selectedTable ? selectedTable.value : '')
                      )
                    "
                    variant="primary"
                    :disabled="!selectedTable"
                    class="mt-2"
                  >
                    Show Selected Table Chat
                  </b-button>
                </b-card>
              </b-col>

              <b-col class="col-lg-5 mt-4 mx-2">
                <b-card
                  header-tag="header"
                  footer-tag="footer"
                  class="broadcast-card h-100"
                >
                  <template #header>
                    <b>Broadcast Message</b>
                  </template>
                  <b-card-text>
                    <div class="table-list-container">
                      <div class="multiselect-wrapper position-relative">
                        <multiselect
                          v-model="selectedTables"
                          :options="tableOptions"
                          label="label"
                          track-by="value"
                          :multiple="true"
                          :placeholder="'Select Tables'"
                          :searchable="true"
                          :internal-search="true"
                          :clear-on-select="false"
                          :show-labels="false"
                          :options-limit="300"
                          :limit="3"
                          :max-height="600"
                          :disabled="!tableOptionsLoaded"
                          :loading="!tableOptionsLoaded"
                        />
                        <a
                          href="#"
                          @click.prevent="selectAllTables"
                          :class="{ 'text-muted': !tableOptionsLoaded }"
                          class="select-all-link"
                          >Select All</a
                        >
                      </div>
                    </div>
                  </b-card-text>
                  <div class="message-input-container">
                    <b-form-input
                      v-model="broadcastMessage"
                      placeholder="Enter message"
                      :class="{ 'is-invalid': isInvalidBroadcastMessage }"
                    />
                    <div class="button-group mt-2">
                      <b-button-group>
                        <b-button
                          type="submit"
                          variant="primary"
                          @click="handleBroadcastSubmit(1)"
                          :disabled="
                            isBroadcastSending ||
                              !selectedTables ||
                              selectedTables.length === 0
                          "
                        >
                          <span v-if="isBroadcastSending"
                            ><i class="fas fa-spinner fa-spin"></i
                          ></span>
                          <span v-else>To dealer</span>
                        </b-button>
                        <b-button
                          type="submit"
                          variant="success"
                          @click="handleBroadcastSubmit(2)"
                          :disabled="
                            isBroadcastSending ||
                              !selectedTables ||
                              selectedTables.length === 0
                          "
                        >
                          <span v-if="isBroadcastSending"
                            ><i class="fas fa-spinner fa-spin"></i
                          ></span>
                          <span v-else>To All</span>
                        </b-button>
                        <b-button
                          v-if="isBroadcastSending"
                          variant="danger"
                          @click="stopBroadcast"
                        >
                          <i class="fas fa-stop"></i> Stop
                        </b-button>
                      </b-button-group>
                    </div>
                    <b-progress
                      v-if="broadcastProgress > 0 && broadcastProgress < 100"
                      :value="broadcastProgress"
                      :max="100"
                      show-value
                      class="mt-2"
                      variant="info"
                    >
                      {{ broadcastProgress }}%
                    </b-progress>
                  </div>
                </b-card>
              </b-col>
            </div>
            <b-col
              v-for="table in sortedTables"
              :key="table.tableId"
              class="col-lg-4 mt-4"
            >
              <b-card
                header-tag="header"
                footer-tag="footer"
                class="table-card"
              >
                <template #header>
                  <b
                    >Table: {{ table.tableId }}, {{ table.name }}; Dealer:
                    <span v-if="croupierNames[table.tableId]">{{
                      croupierNames[table.tableId]
                    }}</span>
                    <span v-else>—</span>
                  </b>
                </template>
                <b-card-text
                  >Number of users:
                  <b>{{ countUsers(table) }}</b>
                  <br />
                  Number of messages:
                  <b>{{ Object.keys(table.messages).length }}</b>
                </b-card-text>
                <b-button
                  @click="$router.push('/admin-chat/' + table.tableId)"
                  variant="primary"
                  >Show chat</b-button
                >
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-card-group>
    </section>
  </div>
</template>
<style>
.chat-area {
  background: #030303;
  height: 30vh;
  padding: 1em;
  overflow: auto;
  width: 650px;
  margin: 0 auto 0 auto;
  box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.3);
}

.message {
  width: 99%;
  border-radius: 10px;
  padding: 0.5em;
  font-size: 1em;
}

.message-out {
  background: #2b2b2d;
  color: red;
}

.message-in-system {
  background: #2b2b2d;
  color: yellow;
}

.message-in-user {
  background: #2b2b2d;
  color: white;
}

.chat-inputs {
  display: flex;
  justify-content: space-between;
}

#person1-input {
  padding: 0.5em;
}

#person2-input {
  padding: 0.5em;
}

.table-card,
.custom-table-card {
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.custom-table-card {
  background-color: #e6f2ff;
  border-left: 5px solid #0056b3;
}

.custom-table-card .card-header {
  background-color: #007bff;
  color: #ffffff;
  font-weight: 300px;
}

.custom-table-card .card-footer {
  background-color: #e9ecef;
}

.message-input-container {
  margin-top: 15px;
  margin-bottom: 15px;
}

.button-group {
  display: flex;
  justify-content: flex-end;
}

.broadcast-card {
  background-color: #f8f9fa;
  border-left: 5px solid #28a745;
}

.broadcast-card .card-header {
  background-color: #28a745;
  color: #ffffff;
  font-weight: 300px;
}

.broadcast-card .card-footer {
  background-color: #e9ecef;
}

.multiselect-wrapper {
  position: relative;
  margin-bottom: 20px;
  padding: 5px 0;
}

.table-list-container {
  padding: 10px 0;
}

.select-all-link {
  position: absolute;
  bottom: -25px;
  right: 0;
  font-size: 0.85rem;
}

.h-100 {
  height: 100%;
}

.custom-table-card,
.broadcast-card {
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.multiselect-wrapper {
  margin-bottom: 30px;
}
</style>

<script>
import { getRouteIcon, ROUTE_ADMIN_CHAT } from '@/utils/routerIcons'
import FilterButtons from '@/components/FilterButtons'
import AdminChatAddForm from '@/components/AdminChat/AdminChatAddForm'
// import Vue from 'vue'
import Multiselect from 'vue-multiselect'

const colorsMap = {
  green: '#00ff00'
}
const historyChatHorus = 24 * 30
const refreshChatMs = 10000

export default {
  components: {
    AddForm: AdminChatAddForm,
    FilterButtons,
    Multiselect
  },
  data() {
    return {
      tables: [],
      formValues: this.getInitialValues(),
      submitType: 1,
      isSending: [],
      isNeedScroll: [],
      isInvalidMessage: [],
      pollingTableStatuses: null,
      pollingCroupierNames: null,
      tableOptions: [],
      tableOptionsLoaded: false,
      selectedTable: null,
      selectedTables: [],
      broadcastMessage: '',
      isBroadcastSending: false,
      isInvalidBroadcastMessage: false,
      broadcastProgress: 0,
      shouldStopBroadcast: false
    }
  },
  computed: {
    croupierNames() {
      return this.$store.getters['tableStatuses/croupierNames']
    },
    countUsers: () => table => {
      let users = new Set()
      Object.values(table.messages).forEach(message => {
        if (message.userName) {
          users.add(message.userName)
        }
      })
      return users.size
    },
    routeIcon: () => getRouteIcon(ROUTE_ADMIN_CHAT),
    tablesFromStore() {
      return this.$store.getters['tablesForSelect/list'] || []
    },
    sortedTables() {
      const tablesArray = Object.values(this.tables || {})

      return tablesArray.sort((a, b) => {
        const aMessages = Object.values(a.messages || {})
        const bMessages = Object.values(b.messages || {})

        if (!aMessages.length) return 1
        if (!bMessages.length) return -1

        const aLatestMessage = aMessages.reduce((latest, current) => {
          const currentDate = this.parseTimestamp(current.timestamp)
          const latestDate = this.parseTimestamp(latest.timestamp)
          return currentDate > latestDate ? current : latest
        }, aMessages[0])

        const bLatestMessage = bMessages.reduce((latest, current) => {
          const currentDate = this.parseTimestamp(current.timestamp)
          const latestDate = this.parseTimestamp(latest.timestamp)
          return currentDate > latestDate ? current : latest
        }, bMessages[0])

        const aDate = this.parseTimestamp(aLatestMessage.timestamp)
        const bDate = this.parseTimestamp(bLatestMessage.timestamp)

        return bDate - aDate
      })
    }
  },
  watch: {
    tablesFromStore: {
      handler(newTables) {
        if (newTables && newTables.length > 0) {
          this.tableOptions = newTables.map(table => {
            return {
              label: `${table.value} - ${table.label}`,
              value: table.value
            }
          })
          this.tableOptionsLoaded = true
        }
      },
      immediate: true
    }
  },
  methods: {
    getInitialValues() {
      return {
        apiKey: process.env.VUE_APP_CHAT_API_KEY,
        message: null,
        color: 'red',
        username: 'admin',
        tableIds: null,
        type: 1
      }
    },
    loadTableOptions() {
      this.$store.dispatch('tablesForSelect/loadList')
    },
    loadChats(hours) {
      let dateFrom = new Date()
      dateFrom.setHours(dateFrom.getHours() - hours)
      this.$http({
        url: '/api/v1/admin-chat',
        params: {
          dateFrom: dateFrom
        },
        method: 'GET'
      })
        .then(resp => {
          let tables = resp.data
          if (this.tables.length === 0) {
            this.tables = tables
            return
          }
          for (let id in tables) {
            for (let messageId in tables[id].messages) {
              if (this.tables[id] === null || this.tables[id] === undefined) {
                this.tables = tables
              }
              this.tables[id].messages[messageId] =
                tables[id].messages[messageId]
            }
            if (
              this.isNeedScroll[tables[id].tableId] === undefined ||
              this.isNeedScroll[tables[id].tableId] === true
            ) {
              this.scrollDown(tables[id].tableId)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {})
    },
    async updateCroupierNames() {
      await this.$store.dispatch('tableStatuses/updateCroupierNames')
    },
    refreshChat() {
      if (this.pollingTableStatuses) {
        clearInterval(this.pollingTableStatuses)
      }
      this.pollingTableStatuses = setInterval(() => {
        this.loadChats(1)
      }, refreshChatMs)

      if (this.pollingCroupierNames) {
        clearInterval(this.pollingCroupierNames)
      }

      this.pollingCroupierNames = setInterval(() => {
        this.updateCroupierNames()
      }, 15000)
    },
    handleSubmit(tableId) {
      if (!this.isValidMessage(this.formValues[tableId])) {
        this.isInvalidMessage[tableId] = true
        return
      }
      this.isInvalidMessage[tableId] = false
      this.isSending[tableId] = true
      let data = {
        ...this.formValues,
        message: this.formValues[tableId],
        type: this.submitType,
        color: colorsMap[this.formValues.color] ?? this.formValues.color,
        tableIds: [tableId]
      }

      this.$http({
        url: '/api/v1/admin-chat',
        method: 'POST',
        data: data,
        headers: { 'Content-Type': 'application/json' }
      })
        .then(() => {
          this.formValues[tableId] = ''
          this.isSending[tableId] = false
          this.isNeedScroll[tableId] = true
        })
        .catch(err => {
          this.isSending[tableId] = false
          this.$toastr.e(JSON.stringify(err.response.data.message))
          throw err
        })
    },
    isValidMessage(message) {
      return message.match(/.*[^ ].*/g) !== null
    },
    scrollDown(tableId) {
      setTimeout(() => {
        for (let i in this.$refs.chatArea) {
          if (
            tableId ===
              parseInt(this.$refs.chatArea[i].getAttribute('data-tableId')) &&
            (this.isNeedScroll[tableId] === undefined ||
              this.isNeedScroll[tableId] === true)
          ) {
            this.$refs.chatArea[i].scrollTop = this.$refs.chatArea[
              i
            ].scrollHeight
          }
        }
      }, 300)
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    handleScroll(event) {
      const tableId = event.currentTarget.getAttribute('data-tableId')
      const currentScrollTop = event.currentTarget.scrollTop
      const scrollHeight =
        event.currentTarget.scrollHeight - event.currentTarget.offsetHeight

      if (scrollHeight - currentScrollTop > 0) {
        this.isNeedScroll[tableId] = false
      }
      if (scrollHeight - currentScrollTop < 2) {
        this.isNeedScroll[tableId] = true
      }
    },
    selectAllTables() {
      this.selectedTables = [...this.tableOptions]
    },
    stopBroadcast() {
      this.shouldStopBroadcast = true
      this.$toastr.i('Stopping broadcast after current message completes...')
    },
    async handleBroadcastSubmit(type) {
      if (!this.isValidMessage(this.broadcastMessage)) {
        this.isInvalidBroadcastMessage = true
        return
      }

      this.isInvalidBroadcastMessage = false
      this.isBroadcastSending = true
      this.broadcastProgress = 0
      this.shouldStopBroadcast = false

      const tableIds = this.selectedTables.map(table => table.value)
      const totalTables = tableIds.length
      let processedTables = 0
      let errorCount = 0

      try {
        for (const tableId of tableIds) {
          if (this.shouldStopBroadcast) {
            this.$toastr.w(
              `Broadcast stopped after ${processedTables} of ${totalTables} tables`
            )
            break
          }

          try {
            await this.$http({
              url: '/api/v1/admin-chat',
              method: 'POST',
              data: {
                ...this.formValues,
                message: this.broadcastMessage,
                type: type,
                color:
                  colorsMap[this.formValues.color] ?? this.formValues.color,
                tableIds: [tableId]
              },
              headers: { 'Content-Type': 'application/json' }
            })
          } catch (requestError) {
            console.error(
              `Error sending message to table ${tableId}:`,
              requestError
            )
            this.$toastr.w(
              `Failed to send message to table ${tableId}: ${requestError
                .response?.data?.message || requestError.message}`
            )
            errorCount++
          } finally {
            processedTables++
            this.broadcastProgress = Math.round(
              (processedTables / totalTables) * 100
            )
          }
        }

        if (!this.shouldStopBroadcast) {
          this.broadcastMessage = ''
          this.selectedTables = []

          if (errorCount === 0) {
            this.$toastr.s('Messages sent successfully to all selected tables')
          } else if (errorCount < totalTables) {
            this.$toastr.w(
              `Messages sent with ${errorCount} errors out of ${totalTables} tables`
            )
          } else {
            this.$toastr.e('Failed to send messages to any table')
          }
        }
      } catch (error) {
        this.$toastr.e(
          'An unexpected error occurred: ' + (error.message || 'Unknown error')
        )
      } finally {
        this.isBroadcastSending = false
        this.shouldStopBroadcast = false
        setTimeout(() => {
          this.broadcastProgress = 0
        }, 3000)
      }
    },
    parseTimestamp(timestamp) {
      if (!timestamp) return 0

      try {
        const parts = timestamp.split(' ')
        const dateParts = parts[0].split('-')

        const correctedDate = `${dateParts[0]}-${dateParts[2]}-${dateParts[1]}`
        const dateTimeStr = `${correctedDate} ${parts[1]}`

        return new Date(dateTimeStr).getTime()
      } catch (e) {
        console.error('Error parsing timestamp:', e)
        return 0
      }
    }
  },
  created() {
    this.loadTableOptions()
  },
  mounted() {
    this.loadChats(historyChatHorus)
    this.updateCroupierNames()
    this.refreshChat()
  },
  destroyed() {
    if (this.pollingTableStatuses) {
      clearInterval(this.pollingTableStatuses)
      this.pollingTableStatuses = null
    }
    if (this.pollingCroupierNames) {
      clearInterval(this.pollingCroupierNames)
      this.pollingCroupierNames = null
    }
  }
}
</script>
